module.exports = __webpack_public_path__ + "static/media/5DPO20.9a26e0c4.jpg";